import IngkaHyperlink, { HyperlinkProps } from '@ingka/hyperlink';
import React, { MouseEvent, RefObject } from 'react';

const Hyperlink = ({
    children,
    onClick,
    ...props
}: HyperlinkProps & { ref?: RefObject<HTMLAnchorElement> }) => {
    // Prevent default hyperlink behaviour that causes scrolling to the top of the page
    const _onClick = (e: MouseEvent<HTMLAnchorElement>) => {
        if (!onClick) {
            return;
        }
        e.preventDefault();
        onClick(e);
    };
    return (
        <IngkaHyperlink prefix="list-ingka-" onClick={_onClick} {...props}>
            {children}
        </IngkaHyperlink>
    );
};

export default Hyperlink;
